(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bizcharts"), require("react"), require("react-dom"), require("DataSet"));
	else if(typeof define === 'function' && define.amd)
		define(["bizcharts", "react", "react-dom", "DataSet"], factory);
	else if(typeof exports === 'object')
		exports["antd-pro-charts"] = factory(require("bizcharts"), require("react"), require("react-dom"), require("DataSet"));
	else
		root["antd-pro-charts"] = factory(root["bizcharts"], root["React"], root["ReactDOM"], root["DataSet"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_bizcharts__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__, __WEBPACK_EXTERNAL_MODULE__antv_data_set__) {
return 